export enum CustomerDefinedFieldDefinitionSourcePath {
  ANHAENGE = 'ANHAENGE',
  AUSSTATTUNG = 'AUSSTATTUNG',
  BIETERVERFAHREN = 'BIETERVERFAHREN',
  FLAECHEN = 'FLAECHEN',
  FREITEXTE = 'FREITEXTE',
  GEO = 'GEO',
  IMMOBILIE = 'IMMOBILIE',
  INFRASTRUKTUR = 'INFRASTRUKTUR',
  OBJEKTKATEGORIE = 'OBJEKTKATEGORIE',
  PREISE = 'PREISE',
  VERWALTUNGS_OBJEKT = 'VERWALTUNGS_OBJEKT',
  VERWALTUNG_TECHN = 'VERWALTUNG_TECHN',
  WEITERE_ADRESSE = 'WEITERE_ADRESSE',
  ZUSTAND_ANGABEN = 'ZUSTAND_ANGABEN'
}

export interface CustomerDefinedFieldDefinition {
  id: string;
  type: CustomerDefinedFieldType;
  label: string;
  order: number;
  readOnly: boolean;
  sourcePath: CustomerDefinedFieldDefinitionSourcePath;
}

export interface MappedCustomerDefinedFieldValue {
  fieldDefinitionId: string;
  label: string;
  type: CustomerDefinedFieldType;
  value: CustomerDefinedValueOptions;
}

export interface CustomerDefinedFieldValue {
  definition: CustomerDefinedFieldDefinition;
  value: CustomerDefinedValue;
}

export interface CustomerDefinedValue {
  type: CustomerDefinedFieldType;
  value: CustomerDefinedValueOptions;
}

export type CustomerDefinedValueOptions = boolean | number | string | Date;

export interface CustomerDefinedFieldValuesForm extends CustomerDefinedValue {
  fieldDefinitionId: string;
  label: string;
}

export interface CustomerDefinedValuesPayload {
  fieldDefinitionId: string;
  value: CustomerDefinedValue;
}

export enum CustomerDefinedFieldType {
  BOOLEAN = 'BOOLEAN',
  DECIMAL_NUMBER = 'DECIMAL_NUMBER',
  WHOLE_NUMBER = 'WHOLE_NUMBER',
  STRING = 'STRING',
  DATE = 'DATE'
}
